/*
 * Copyright (c) 2017-2018. Code réalisé par IpsoSenso
 */

import { flatten } from 'flat'
import { cmsMessagesEn } from 'isotope-client-cms'

export default flatten({
	isotope : {
		datatable: {
			header: {
				selected: '{numSelected, plural, =0 {None item selected} one {1 item selected} other {# items selected}}'
			},
			footer: {
				elementsPerPage: 'Items per page :',
				pagination: '{startIndex, number} - {endIndex, number} of {total, number}'
			}
		}
	},
	cms: {
		...cmsMessagesEn,
		entities: {
			tenderbox: 'Modification of the Tender Box presentation page',
			visiteur: 'Modification of the visitor block',
			presentation: 'Modification of the presentation block',
			contact: 'Modification of the contact block',
			correspondant: 'Modification of the correspondent block'
		},
		fields: {
			title: 'Block title *',
			content: 'Bloc content'
		}
	},
	notify: {
		success: 'Content saved',
		error: 'An error has occurred'
	},
	btn: {
		save: 'Save',
		cancel: 'Cancel'
	},
	global: {
		messages: {
			accueilFO: 'A monitoring plugin is used temporarily to allow us to improve the tools according to your uses.'
		},
		link: {
			viderFiltre: 'Clear all criteria'
		},
		buttons: {
			rechercher: 'Search',
			voirPlus: 'See more...',
			annuler: 'Cancel',
			confirm: 'Confirm',
			compris: 'Understood',
			more: 'MORE DETAILS',
			save: 'Save',
			save_filter: 'Save',
			send: 'Send',
			close: 'Close',
			add: 'Add',
			validate: 'Validate',
			delete: 'Delete',
			updateFields: 'Update fields',
			update: 'Update',
			loginGoogle: 'SIGN IN WITH GOOGLE'
		},
		errors: {
			droitsInsuffisants: 'Your current access rights do not allow you to access this page',
			obligatoire: 'This field must be filled in',
			formulaire: 'You must fill in the required fields',
			formatEmail: 'The format of the e-mail is not valid',
			amountObligatoire: 'You must enter a currency',
			amountObligatoireMontant: 'You must enter an amount',
			emptyMessageError: ' '
		},
		yes: 'Yes',
		no: 'No',
		workInProgress: 'Work in progress',
		no_results: 'There\'s no results.',
		resultTitle: '{results, plural, one {Result} other {Results}} Search ({results, number})',
		tris: {
			pertinence: 'By relevance',
			a_z: 'A ⇒ Z',
			z_a: 'Z ⇒ A',
			date_connexion_desc: 'Date of last connection from most to least recent',
			date_connexion_asc: 'Date of last connection at least to most recent',
			date_modification_desc: 'Most to least recent modification date',
			date_modification_asc: 'Least to most recent modification date',
			like: 'Most Liked Contents'
		},
		more: {
			export_result: 'Export results',
			partage_result: 'Share search',
			ajouter_favoris_result: 'Add search to favorites',
			ajouter_favoris_result_notif_on: 'Add search to favorites with notification'
		},
		NA: 'Not specified'
	},
	menu: {
		boParametrageMenu: 'CONFIGURATION',
		boPropositionCommercial: 'Proposals',
		boSavoirFaire: 'Know-How',
		boReference: 'References',
		boValueList: 'List of values',
		additionalFilters: 'Custom filters',
		boPersonnalisationMenu: 'CUSTOMIZATION',
		boBlocPresentation: 'Presentation block',
		boBlocVisiteur: 'Visitor\'s block',
		boBlocContact: 'Contact block ',
		boBlocCorrespondant: 'Correspondent block',
		returnFo: 'Front office',
		admin: 'Functional Administration',
		accueilMenu: 'Home page',
		contenuMenu: 'CONTENTS',
		rechercherContenu: 'Search for content',
		ajouterContenu: 'Add a content',
		contribution: 'My Contributions',
		contenuAValider: 'Content to be validated',
		contenuAPublier: 'Content to be published',
		contenuARetirer: 'Content to be removed',
		annuaireMenu: 'DIRECTORY',
		correspondanceZone: 'Zone Correspondents',
		demandeAcces: 'Request a member access',
		demandeAttente: 'Pending applications',
		listeUtilisateur: 'User List',
		aideContactMenu: 'HELP & CONTACT',
		presentationTenderBox: 'Tender Box presentation',
		formContact: 'Contact the Tender Box team'
	},
	favoris: {
		addSearch: {
			success: 'Your search has been added to your favourites',
			error: 'Your search could not be added to the favourites'
		},
		document: 'Contents',
		emptyDocument: 'You haven\'t saved any content as a bookmark yet',
		search: 'Research',
		emptySearch: 'You haven\'t registered a search yet',
		searchItem: 'Search saved on',
		deleteSearchTitle: 'Delete a favorite search',
		deleteDocumentTitle: 'Deleting a bookmarked document',
		deleteSearchDescription: 'Do you really want to delete this search from your favorites?',
		deleteDocumentDescription: 'Are you sure you want to delete the content of the favorites?',
		updateSearch: {
			success: 'Your search has been updated',
			error: 'Your search could not be updated'
		},
		deleteSearch: {
			success: 'Your search has been deleted',
			error: 'Your search could not be deleted'
		}
	},
	appBar: {
		menus: {
			monCompte: 'My Account',
			cookies: 'Manage my cookies',
			logout: 'Log out'
		}
	},
	accueilBo: {
		title: 'Welcome to administration'
	},
	translation: {
		inputLabel: 'Translation',
		button: 'Translate'
	},
	searchBar: {
		placeHolder: 'Search in Tender Box',
		all: 'All contents'
	},
	autocompleteMulti: {
		placeHolder: 'Select'
	},
	constants: {
		request: {
			VALID: 'Validated',
			TO_VALIDATE: 'To be validated'
		},
		profils: {
			VISITEUR: 'Visitor',
			MEMBRE: 'Member',
			CORRESPONDANT: 'Correspondent',
			ADMIN: 'Administrator'
		},
		user_connecte: {
			SEMAINE: 'Within the week',
			MOIS: 'Within the month',
			TRIMESTRE: 'In the quarter',
			ANNEE: 'Within the year'
		}
	},
	users: {
		title: 'Search',
		listeUsers: 'User List ',
		listeDemandes: 'Requests to be validated ',
		listeCorrespondants: 'Manager',
		demandeCorrespondant: 'Would you like to become a manager?',
		click: 'Click here',
		noResults: 'There are no users matching your research',
		search: {
			filterTitle: 'Search',
			default: 'Indifferent',
			nameLabel: 'Name',
			zoneLabel: 'Zone',
			paysLabel: 'Country',
			paysOrigineLabel: 'Country of origin',
			marcheLabel: 'Market',
			segmentLabel: 'Business segment',
			profilLabel: 'Profile',
			demandeLabel: 'Request',
			connecteLabel: 'Connected users'
		},
		export: {
			headers: {
				nom: 'Name',
				prenom: 'First name',
				zone: 'Zone',
				statut: 'Status',
				dateAjoutStatut: 'Update status',
				dateDerniereConnexion: 'Date of last connexion'
			},
			fileName: 'Export des utilisateurs'
		},
		actions: {
			valid: 'Validate',
			donDroits: 'Give the member rights',
			refuse: 'Refuse',
			delDroits: 'Withdraw member\'s access',
			modify: 'Modify user account'
		},
		accesRequest: {
			demande: 'Access requested on: ',
			valide: 'Access validated on: ',
			refuse: 'Access denied: ',
			derniereCo: 'Last login on: ',
			refusAuto: 'Automatic rejection'
		},
		popin: {
			validation: {
				titlePopin: 'Give the member rights',
				messagePopin: 'Do you confirm the allocation of member rights to ',
				success: 'The access request has been validated.',
				error: 'An error occurred during the validation of the request.'
			},
			refus: {
				titleRefus: 'Refuse a request for access',
				titleRetire: 'Withdraw member\'s access ',
				messageRefus: 'Do you confirm the rejection of the request for access from ',
				messageRetire: 'Do you confirm the withdrawal of member\'s access to  ',
				field: 'Justification *',
				success: 'The request for refusal has been validated',
				error: 'An error occurred during the refusal request'
			}
		}
	},
	oss: {
		popinChoixFields: {
			title: 'Selection of columns to display ({sizeColumns}/50 columns maximum)',
			sectionChampsAvances: 'Advanced data',
			maxColumnReached: 'You can not display more than 50 columns on the table'
		},
		tooltip: {
			accesEditList: 'Edit references',
			accesViewList: 'Visualization of searched references'
		},
		tabDocumentPage: {
			titleEdition: 'Content modification',
			titleConsultation: 'Visualization of content',
			table: {
				headerTitle: 'References'
			},
			tooltip:{
				fieldNotFoundLang: 'This data is not yet specified in the selected language, to fill it, go directly to the reference.',
				notEditable: 'This data impacted the structure of the reference, to modify it, go directly to the reference sheet.',
				cantModify: 'This data is not yet specified in the selected language, to fill it, go directly to the reference sheet.',
				notExist: 'This data is empty in any of the languages, to fill it, go directly to the reference sheet.'
			},
			snackBar: {
				tabInfo: 'This modification mode allows you to see only the references for which you have the modification rights.',
				editFieldSucces: 'Modification taken into account.',
				editFieldError: 'Modification failed',
				tabModificationInfo: 'This modification mode allows you to see only the references for which you have the modification rights.',
				tabConsultationInfo: 'This viewing mode allows you to consult all the references except the confidential data represented by a *.'
			}
		},
		actionBar:{
			editColumns: 'Add/remove columns'
		},
		popin: {
			shareTitle: {
				title: 'Share the table'
			}
		}
	},
	document: {
		search: {
			collapse: {
				location: 'LOCATION',
				clients: 'CLIENTS',
				activities: 'ACTIVITES',
				document: 'TYPES OF DOCUMENT',
				additional: 'ADDITIONAL FILTERS',
				admin: 'ADMINISTRATOR FILTERS'
			},
			additionalInfos: 'Looking for another criterion?',
			additionalAddInfos: 'Click here to search for a specific data',
			adminInfos: 'Click here to add an administrator filter',
			correspondantInfos: 'Click here to add a correspondant filter',
			title: 'Search in Tender Box',
			titleMesContrib: 'My contributions',
			titleAValider: 'Contents to be validated',
			titleAPublier: 'Contents to be published',
			titleARetirer: 'Content to withdraw',
			filterTitle: 'Search Criteria',
			default: 'Indifferent',
			queryPlaceholder: 'Search in Tender Box',
			typeContenuLabel: 'Types of content',
			typeContenuDefault: 'All',
			langueLabel: 'Language',
			zoneLabel: 'Zone',
			marketLabel: 'Market',
			sectorLabel: 'Sector',
			businessSegmentLabel: 'Business segment',
			businessSubSegmentLabel: 'Sub-Segment',
			coreBusinessLabel: 'Core business',
			bidBriefLabel: 'Part of the bid brief',
			paysLabel: 'Country',
			proposalStatusLabel: 'Status of the proposal',
			withAttachmentLabel: 'With attachments',
			internalExternalLabel: 'Internal - External',
			noResults: 'There is no content matching your search',
			correspondant: {
				title: 'CORRESPONDENT FILTER',
				info: 'When one of the filters below is applied, the search will be carried out only on the contents for which you are correspondent'
			},
			field: {
				noInput: 'Please enter a value',
				noValue: 'No corresponding  value'
			},
			advance: {
				title: 'Advanced filters',
				addFilter: 'Add a filter',
				description: 'You can select below the recommended filters proposed according to the selected sub-segments. \n' +
					'If you are looking for a different specific data select the "<strong>Other data</strong>" choice which allows you to search for a specific data.',
				removeFilter: 'Clear all filters',
				showOnlyAttachments: 'Show only content with attachment',
				appliedFilters: 'Applied filters',
				appliedFiltersDescription: 'Additional filters applied appear here',
				newFilter: {
					title: 'New Filter',
					field: {
						searchKey: 'Additional filter',
						searchNumber: 'Equal, higher or lower',
						searchDate: 'Before, After',
						searchText: 'Contains, does not contain',
						placeholderText: 'Search for value',
						otherData: 'Search another data',
						dataName: 'Data name',
						attachment: 'Show only content with attachment',
						and: '{lessThan} and {greaterThan}',
						EQUAL: 'Equal to',
						NOT_EQUAL: 'Different from',
						SUPERIOR: 'Higher than',
						INFERIOR: 'Lower than',
						BEFORE: 'Before',
						AFTER: 'After',
						INCLUDE: 'Contains',
						NOT_INCLUDE: 'Does not contain',
						BETWEEN: 'Between',
						EQUAL_DATE: 'The ',
						errorBetween: 'Cannot be less than the first value',
						errorBetweenDate: 'Cannot be earlier than the first date'
					},
					button: 'Filter',
					closeButton: 'Cancel'
				}
			},
			adminPopin: {
				title: 'Administrators filters',
				description: 'You have the ability to filter information here restricted to administrators such as the status of the content, the contributor, creation date, date of submission, date of publication and more.',
				fields: {
					adminFilter: 'Administrator filter'
				}
			},
			correspondantPopin: {
				title: 'Correspondent filters',
				description: 'You have the ability to filter information here restricted to correspondents such as the status of content, contributor and more. When a filter is applied here, the search is made only on the contents of which you are the correspondent.',
				fields: {
					correspondantFilter: 'Correspondent filter'
				},
				typeField: {}
			},
			adminCorrespondantPopin: {
				errors:{
					date2Beforedate1 : 'Invalid dates'
				},
				fields: {
					status: 'Content Status',
					contributor: 'Contributor',
					dateCreation: 'Creation date',
					dateSoumission: 'Submission date',
					datePublication: 'Publication date',
					publierPar: 'Administrator who published the content',
					dateLastModif: 'Last Modified',
					modifierPar: 'User with a modified last content',
					dateMasqued: 'Date of removal',
					masquerPar: 'Administrator having removed content'
				},
				radioGroup: {
					after: 'After the ',
					at: 'The ',
					before: 'Before ',
					between: 'Between '
				},
				appliedFilters: 'Applied filters:',
				emptyStateFilters: 'Additional filters applied appear here',
				cardTitle: {
					status: 'Status',
					contributor: 'Contributor',
					dateCreation: 'Created',
					dateSoumission: 'Submitted',
					datePublication: 'Published',
					publierPar: 'Published by',
					dateLastModif: 'Last modification date',
					modifierPar: 'Last edition by',
					dateMasqued: 'Took of',
					masquerPar: 'Hidden by'
				},
				filterDateBetween: 'Between {dateDebut} and {dateFin}'
			},
			share: {
				title: 'Share search',
				description: 'Fill in the e-mail addresses of the recipient(s) separated by a ";" so that they can access the search you have made ',
				form: {
					email: 'Recipient email',
					commentaire: 'Complementary message'
				},
				success: 'Your search has been shared'
			},
			export: {
				sent: 'Your search is being exported. You will receive an e-mail when the document is available.',
				title: 'Export the result table',
				description: 'You\'re about to export the results of your search. You can select here the different columns you want to appear on your table and order them according to your needs',
				selection: 'Column selection',
				selected: 'Selected columns',
				default: 'Default columns',
				add: 'Add',
				remove: 'Remove',
				placeholder: 'Columns to export',
				send: 'Export table'
			},
			notFound: 'No search matches the specified id',
			addToFavorite: {
				title: "Edit a saved search",
				form: {
					title: "Search Title",
					notification: "Weekly monitoring"
				}
			}
		},
		card: {
			created: 'Created on: ',
			contributor: 'Contributor: ',
			modified: 'Updated on: ',
			modifiedBy: 'Updated by: ',
			submit: ' Submitted on: ',
			submitBy: 'Submitted by: ',
			validated: 'Validated on: ',
			published: 'Published on:',
			publishedBy: 'Published by: ',
			masked: 'Hidden on: ',
			maskedBy: 'Hidden by: ',
			toDelete: 'Requested suppression the:',
			toDeleteBy: 'Requested deletion by: ',
			toMask: 'Request masked the:',
			toMaskBy: 'Request masked by : '
		},
		newDocumentPage: {
			propositionCommercial: {
				titre: 'Proposal',
				description: 'Proposal-type enables you to share the information and documents given to the client for a Tender. \nSome data may be declared confidential, and therefore not visible to the majority of Tender Box users ',
				libelleLien: 'ADD A PROPOSAL'
			},
			savoirFaire: {
				titre: 'Know-how',
				description: 'Know-how-type content allows you to share specific information related to the know-how from Veolia, and to re-use it for a tender, or in a report.',
				libelleLien: 'ADD A KNOW-HOW'
			},
			reference: {
				titre: 'Reference',
				description: 'Reference-type content allows you to share commercial and technical data on Veolia projects. Some data may be declared confidential, and therefore not visible to the majority of Tender Box users',
				libelleLien: 'ADD A REFERENCE'
			}
		},
		submittingInfo: 'Due to a Google restriction in the copying process, the upload of folders and files may take several minutes. Please do not close this tab during saving.',
		saveSuccess: 'Information saved. This saving and its visibility on Tender Box may take some time depending of the number and size of the attachments.',
		newContent: 'New content ',
		editContent: 'Content modification',
		retour: 'Return',
		saveRequiredPublication: 'Registration is required to change the status',
		saveRequired: 'Registration is required to change language',
		errorField: 'The field “{fieldName}” must be correctly filled in ',
		globalReport: {
			tooltip: 'Update of the sheet',
			popin: {
				title: 'Update of the sheet',
				details: 'Some fields in the form are linked to the Veolia Global Report Data lake. You are about to update these fields with the current data values from Global Report, which will overwrite the values previously entered in these fields.',
				confirm: 'Update'
			},
			success: 'The sheet has been updated'
		},
		entete: {
			title: 'Title',
			zone: 'Zone',
			language: 'Original language',
			contributor: 'Contributor',
			commentaire: 'Comment to the Tender Box team (not published)'
		},
		section: {
			defaultTitle: 'Section title',
			defaultSubtitle: 'Section subtitle',
			switch: 'Indicate this section as completed',
			deleteTitle: 'Delete duplicated section',
			deleteMessage: 'Do you confirm the deletion of this duplicated section?'
		},
		field: {
			confidentiable: 'Confidential data',
			libelleLink: 'Wording',
			urlLink: 'URL',
			defaultValueInfo: 'Database reference value :',
			noValueInGR: 'No reference data for this field.',
			drive: {
				formPlaceHolder : "Search in drive",
				open: 'Open my drive',
				selectFiles: 'Select the corresponding file(s) from your drive',
				infoFolder: 'Only the first five levels of a folder will be imported. Subfolders and files from the 5th level will not be imported. The maximum size of an importable file is 50 MB (no size limit on video files).',
				prefixFolder: 'Folder :',
				errorRights: '{nomFichier} not uploaded (insufficient rights).',
				errorSize: '{nomFichier} not uploaded  (maximum size 50MB).',
				errorGlobal: '{nomFichier} not uploaded (an error occured).',
				uploading: '- Recording in progress ...'
			},
			duns:{
				noresult:"No results found",
				errorApi:"Error calling Duns API",
				dunsLabelName:"Company name",
				dunsGlobalLabelName:"Parent company (world)",
				dunsCountryLabelName:"Parent company (country)",
				searchLink:"Need help to find a DUNS code ?"
			}
		},
		folderPopin: {
			title: 'Composition of the files with the field "{fieldName}"',
			emptyFolder: 'The folder is empty',
			emptySearch: 'No document matches the search'
		},
		statusResponse: {
			error: 'You are not authorized to perform this action.',
			refus: 'The request has been refused.',
			A_VALIDER: 'The content has been submitted.',
			VALIDE: 'The content has been validated.',
			PUBLIE: 'The content has been published.',
			MASQUE: 'The contents have been removed.',
			SUPPRIME: 'The content has been deleted.',
			A_SUPPRIMER: 'The content has been submitted to be deleted.',
			A_MASQUER: 'The content has been submitted to be masked.'
		},
		button: {
			soumettre: 'Submit',
			valider: 'Validate',
			publier: 'Publish',
			retirer: 'Remove'
		},
		menuConsultation: {
			share: 'Share',
			save: 'Export to drive',
			contribute: 'Contribute',
			exportFollow: 'Export for follow-up'
		},
		partage: {
			title: 'Share content',
			ask: 'Do you want to share this content for consultation or contribution?',
			description: 'Fill in the e-mail address(es) of the recipient(s) separated by an";"so that they receive the link to the content.',
			form: {
				contribution: 'Share for contribution',
				consultation: 'Share for consultation',
				email: 'Recipient\'s email *',
				commentaire: 'Additional message'
			},
			success: 'Content sharing was successfully transmitted',
			close: 'Close',
			send: 'Send'
		},
		translate: {
			title: 'Automatic translation',
			ask: 'Select in which language you would like to perform an automatic translation.',
			description: 'Automatic translation will only be done for fields that are left blank in the selected language(s) and the user will always be able to modify them.',
			close: 'Cancel',
			send: 'Translate'
		},
		suivi: {
			success: 'Export is in progress, you will receive an email with the link to\'s access the file.'
		},
		masquerSupprimerDoc: {
			popin: {
				title: 'Request for withdrawal of content',
				detailsBrouillonOrToValidate: 'Since this content is not published yet, it can only be deleted definitively. Do you want to delete it?',
				titleAdmin: 'Remove the contents',
				details: 'Do you want to ask to hide this tender box content or delete it permanently?',
				detailsAdmin: 'Do you want to hide this contents of Tender Box or delete it permanently?',
				detailsMsg: 'You can add a message to the administrator.',
				placeholder: 'Complementary message (250 characters max.) *',
				warningSuppression: 'CAUTION: The suppression is irreversible',
				demandExistMasque: 'A user wants to hide this sheet.',
				demandExistSuppression: 'A user wants to remove this sheet.',
				messageUserForAdmin: 'User\'s message: {message}',
radioGroup: {
	retrait: 'Hide this content',
		suppression: 'Delete definitely',
		rollBackToPublie: 'Cancel the current application'
}
},
snackbar: {
	success: 'Request for withdrawal taken into account',
		error: 'An error has occurred'
}
}
},
contact: {
	title: 'Contact the Tender Box team',
		validation: {
		message: 'Your message has been successfully sent, the Tender Box team will answer you as soon as possible.'
	},
	field: {
		sujet: {
			label: 'Subject *',
				placeholder: 'Select the subject of the message'
		},
		objet: 'Object *',
			message: 'Message *'
	}
},
enums: {
	langue: {
		fr: 'French',
			en: 'English',
			es: 'Spanish',
			pl: 'Polish'
	},
	documentType: {
		REFERENCE: 'Reference',
			PROPOSITION_COMMERCIALE: 'Proposal',
			SAVOIR_FAIRE: 'Know-how'
	},
	profil: {
		ROLE_VISITEUR: 'Visitor',
			ROLE_MEMBRE: 'Member',
			ROLE_CORRESPONDANT: 'Correspondent',
			ROLE_ADMIN: 'Administrator'
	},
	documentStatus: {
		BROUILLON: 'Draft',
			A_VALIDER: 'To be validated',
			VALIDE: 'Validated',
			PUBLIE: 'Published',
			MASQUE: 'Hidden',
			A_SUPPRIMER: 'To delete',
			A_MASQUER: 'To mask'
	},
	documentStatusSummary: {
		BROUILLON: '(draft)',
			A_VALIDER: '(to be validated)',
			VALIDE: '(validated)',
			PUBLIE: '(published)',
			MASQUE: '(hidden)',
			A_SUPPRIMER: '(to delete)',
			A_MASQUER: '(to hide)',
			SUPPRIME: 'Deleted'
	},
	documentStatusContributions: {
		BROUILLON: 'Created on:',
			A_VALIDER: 'Submitted on: ',
			VALIDE: 'Validated on: ',
			PUBLIE: 'Published on:',
			MASQUE: 'Withdrawn from publication on:',
			A_SUPPRIMER: '[SUP] submitted the',
			A_MASQUER: '[Mask] submitted the'
	},
	field: {
		TEXT: 'Text',
		TEXT_MULTILINE: 'Multiline text',
		SELECT: 'Select',
		MULTI_SELECT: 'Multi-select',
		NUMBER: 'Number',
		NUMBER_UNIT: 'Number and unit',
		AMOUNT: 'Amount',
		DATE: 'Date',
		FILE: 'File',
		LINK: 'Link',
		LINK_PROPOSITION: 'Proposal link',
		TABLE: 'Table',
		DUNS: 'TODO-ANG : Code Duns'
	},
	withAttachment:{
		CASE_STUDY: 'Case study',
			CERTIFICATE: 'Certificate'
	},
	internalExternal: {
		INTERNAL: 'Internal',
			EXTERNAL: 'External'
	}
},
modificationUser: {
	title: 'User:',
		titleCompte: 'My account',
		retour: 'Back to search ',
		infoVisiteur: 'As a visitor, you have restricted access to Tender Box.\n' +
	'A member can access many additional features such as\n' +
	'-Enhance the contents of your area by feeding the Tender Box.\n' +
	'-Share your search criteria.\n' +
	'-Create favorites.',
		btnAsk: 'Request an access.',
		form: {
		titlePart: 'Preferences',
			nom: 'Name *',
			prenom: 'First name *',
			email: 'E-mail *',
			zone: 'Zone *',
			zoneVisiteur: 'Make sure this is your country. Once you have requested access, you will not be able to modify it and only an administrator will be able to edit it.',
			profil: 'Profile *',
			FI_COUNTRY: 'Country',
			FI_PRE_CLIENT_MARKET: 'Market',
			FI_SEGMENTS: 'Business Segment',
			FI_PRE_CLIENT_SECTOR: 'Sector',
			FI_SUBSEGMENT: 'Sub-Segment',
			paysOrigine: 'Country of origin *',
			langue: 'Language *',
			devise: 'Currency *',
			su: 'Unit system *',
			paramGestion: 'Management of perimeters',
			paramSubElement: 'Management of Facilitateur',
			error: {
			mandatory: 'This field must be filled in'
		}
	},
	backHome: 'Return to the home page',
		askTitle: 'Request access',
		askMessage: 'Your request has been sent. You will receive a notification by e-mail once your area manager validates or refuses the access.',
		popin: {
		title: 'Editing profile and preferences',
			message: 'Do you confirm the modification made for the profile of ',
			success: 'The user has been edited.',
			error: 'An error occurred during the registration of the user.'
	}
},
accueil: {
	propositionCommerciale: {
		titre: 'Proposals',
			description: 'Proposals are all the documents that have been given to the client during a tender process.<br /><br />' +
				'You will be able to share and download technical memo or synthesis and so one.'
	},
	savoirFaire: {
		titre: 'Know-hows',
			description: 'Know-hows are part of the proposal that were standardized to create one topic to be reused for your tender.<br /><br />' +
				'You will be able to share and download different topics such as Health & Safety, Asset Management, presentation of transversal organization and so one.'
	},
	reference: {
		titre: 'References',
			description: 'References provide contractual, technical and financial information about won contracts. <br /><br />' +
				'You will be able to share and download from case studies to client letters and also many technical KPI. ',
			button: 'Display references with case studies only'
	},
	disponible: 'Available on Tender Box',
		publication: 'Published this month',
		contenuAValider: {
		titre: 'Contents to be validated',
			description: 'These contents have been submitted by Tender Box members from your area. They are waiting for your validation.',
			emptyTitre: 'You don\'t have any content to validate...',
			emptyDescription: 'Here you will find the number of content submitted by Tender Box members from your area, waiting for your validation',
			bouton: 'See these contents'
	},
	contenuAPublier: {
		titre: 'Content to be published',
			description: 'These contents have been submitted by Tender Box members from every area. They are waiting your validation to be published ',
			emptyTitre: 'You don\'t have any content to validate...',
			emptyDescription: 'You will find here the number of content submitted by Tender Box members from every area, waiting for a validation to be published',
			bouton: 'See these contents'
	},
	accesAValider: {
		titre: 'Access requests to validate',
			description: 'These access requests have been submitted by Tender Box visitors  in your area. Validate their requests to allow them to provide content and fully use Tender Box.',
			emptyTitre: 'You have no access to validate...',
			emptyDescription: 'Here you will find the number of requests asked by Tender Box visitors in your area, waiting for validation',
			bouton: 'See these requests'
	},
	accesAValiderAdmin: {
		titre: 'Access request to validate',
			description: 'These access requests has been submitted by Tender Box visitors in every area. They are waiting for validation by the area managers.',
			emptyTitre: 'You have no access to validate...',
			emptyDescription: 'Here you will find the number of requests asked by Tender Box visitors in every area, waiting for validation',
			bouton: 'See these requests'
	},
	top: {
		titre: 'Top 10 Tender Box content',
			description: 'List of the 10 most liked content by the user'
	},
	mesContributions: {
		titre: 'My contributions',
			description: 'Every content I provided',
			add: 'Add content',
			empty: 'You don\'t have any contribution'
	},
	libelleLien: {
		presentation: 'Find out more',
			contact: 'New message',
			correspondant: 'Search',
			visiteur: 'Request an access'
	}
},
parametrage: {
	typeContenu: {
		PROPOSITION_COMMERCIALE: 'Proposal',
			SAVOIR_FAIRE: 'Know-how',
			REFERENCE: 'Reference'
	},
	plan: 'Plan',
		detail: 'Detail',
		section: {
		defaultTitle: 'Section title',
			type: {
			FI: 'Identity card',
				RUBRIQUE: 'Heading',
				STANDARD: 'Standard',
				DOCUMENT: 'Document'
		},
		level: 'level {level}',
			form: {
			REFERENCE: 'References : ',
				new: 'New level 1 section',
				title: 'References: new section',
				parent: 'Parent Section *',
				name: {
				en: 'Section name (English) *',
					fr: 'Section name (French) *',
					es: 'Section name (Spanish) *',
					pl: 'Section name (Polish) *'
			},
			type: 'Section type*',
				titleCode: 'Field code impacting the title',
				after: 'The section appears after the section*',
				first: 'The section is displayed in first position',
				visibility: 'The section\'s visibility is conditioned by a value',
				sectionRegroupement: 'ANG - La section est une rubrique thématique de regroupement',
				reference: 'Reference of the data conditioning the visibility',
				code: 'Value code conditioning visibility',
				publier: 'Publish section',
				traduction: 'Translation',
		},
		createsuccess: 'New section successfully created',
			editsuccess: 'Section successfully modified',
			delete: {
			title: 'Delete section',
				ask: 'Are you sure you want to delete this section?',
				success: 'Section deleted successfully',
				error: {
				child: 'Unable to delete because the section is not empty.',
					fi: 'You can\'t delete the identity card.',
					generic: 'An error occurred while deleting the section.'
			}
		},
		error: {
			isNotEmpty: 'Unpublication not possible because the section contains data / sections that are not unpublished',
				parentNotPublished: 'Unable to publish because parent section is unpublished'
		}
	},
	field: {
		defaultTitle: 'Field title'
	},
	btnSection: 'New section',
		btnField: 'New data',
		btnMajSearch: 'Update search',
		majSearchSuccess: 'Search update in progress',
		updateOrder: {
		success: 'The data\'s position in the section has been updated'
	},
	deleteField: {
		popin: {
			title: 'Data deletion {name}',
				content: 'Are you sure you would like to delete the data {name} ?'
		},
		error: {
			isReferenced: 'Unable to delete, because the data is referenced by the following data:<br />{references}',
				generic: 'An error occurred while deleting the data.'
		}
	},
	donneeForm: {
		newTitle: 'New data',
			fields: {
			sectionParent: 'Parent section',
				nomDonnee: 'Data\'s name ({langue})',
				reference: 'Data reference name',
				nameBigQuery: 'Column reference in BQ export',
				type: 'Data type',
				visibility: {
				check: 'The visibility of the data is conditioned by a value',
					reference: 'Reference name of the data conditioning visibility',
					code: 'Value code conditioning visibilityé'
			},
			defaut: 'Default value',
				confidentiable: 'The user can declare this data confidential',
				donneeAvancee: 'ANG - Cette donnée est une donnée avancée',
				help: 'Help text for contributor({langue})',
				publier: 'Publish the data',
				select: {
				source: 'Origin of the value list',
					reference: 'The content of this list depends on another data',
					referenceParent: 'Reference name of the parent data'
			},
			unite: {
				source: 'Associated SI unit',
			default: 'Default unit'
			},
			table: {
				columnName: 'Column name ({langue})',
					popin: {
					addTitle: 'Add a column',
						editTitle: 'Edit a column'
				}
			}
		},
		fieldTypes: {
			TEXT: 'Text',
				TEXT_MULTILINE: 'Multiline text',
				SELECT: 'Simple select',
				MULTI_SELECT: 'Multiple select',
				NUMBER: 'Number',
				NUMBER_UNIT: 'Number and unit',
				AMOUNT: 'Amount',
				DATE: 'Date',
				FILE: 'Document',
				LINK: 'Link',
				LINK_PROPOSITION: 'Link to another content',
				TABLE: 'Table',
				DUNS: 'TODO-ANG : Code Duns'
		},
		error: {
			isReferenced: 'Unpublication impossible, because the data is referenced by the following data:<br />{references}',
				parentNotPublished: 'Unable to publish because the parent section is not published',
				referenceAlreadyExist: 'This reference name already exists',
				tableReferenceIdentical: 'The table has identical references'
		}
	},
	traduction: 'Translation'
},
additionalFilters: {
	title: 'Additional Filters',
		researchSections: 'Search Sections',
		researchFields: 'Search criteria',
		newSection: 'New section',
		updateSection: 'Edit Section',
		newField: 'New search Field',
		updateField: 'Edit a criteria',
		reset: 'Reset',
		save: 'Save',
		addField: 'Add a criteria',
		form: {
		name: 'Section Name (English) *',
			subSegments: 'Value(s) of the sub-segment conditioning the visibility',
			publishedSection: 'Publish section',
			publishedField: 'Publish field',
			nameFr: 'Section Name (French)',
			nameEs: 'Section Name (Spanish)',
			namePl: 'Section Name (Polish)',
			reference: 'Data reference',
			alreadyUsedReference: 'This code is already used in a research section',
			referenceNotFound: 'Unknown Reference'
	},
	add: {
		snackSuccess: 'Changes saved'
	}
},
valueList: {
	recherche: 'Search',
		valeurs: 'Value',
		form: {
		name: 'Name',
			shortcut: 'Code',
			description: 'Description'
	},
	entries: {
		valeurs: 'Value',
			actif: 'Active',
			inactif: 'Inactive'
	},
	popin: {
		add: 'Add a value',
			edit: 'Edit a value',
			code: 'Code',
			inactif: 'Inactive',
			langue: 'Label {codeLang}'
	}
}
})
